let chartHandler = (function () {
    const t = {};

    /**
     * @type {{top: number, left: number}}
     */
    let area = {
        left: 0,
        top: 0
    };

    /**
     * @type {{chartArea: {}, chart: {}, config: {}}}
     */
    let chart = {
        chart: {},
        chartArea: {},
        config: {}
    };

    let chartInstance = Chart;

    /**
     * Get the current chart instance.
     *
     * @return {*}
     */
    t.getChart = () => {
        return chart;
    };

    /**
     * Get the current chart context instance.
     *
     * @return {*|null}
     */
    t.getArea = () => {
        Object.assign(area, chart.chartArea);
        return area;
    };

    /**
     * Get the current chart context instance.
     *
     * @return {*|null}
     */
    t.getContext = () => {
        return chart.chart.ctx;
    };

    /**
     * Get the current chart context instance.
     *
     * @return {*|null}
     */
    t.getConfigOptions = () => {
        return chart.config.options;
    };

    /**
     * Get the current chart plugin context instance.
     *
     * @return {*}
     */
    t.getPluginService = () => {
        return chartInstance.pluginService;
    };

    /**
     * Get the current chart plugin context instance.
     *
     * @return {*}
     */
    t.setChart = (currentChart) => {
        Object.assign(chart, currentChart);
        return chart;
    };

    /**
     * Constructor
     */
    (function () {
        t.getPluginService().register({
            // Colorize the chart
            // area background.
            beforeDraw: function (chart) {
                // Attach the chart to
                // current instance
                t.setChart(chart);

                let configOptions = t.getConfigOptions() || {};
                let chartBackgroundColor = configOptions.chartArea.backgroundColor || null;
                if (chartBackgroundColor !== null) {
                    let chartContext = t.getContext();
                    let chartArea = t.getArea();

                    chartContext.save();
                    chartContext.fillStyle = chartBackgroundColor;
                    chartContext.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                    chartContext.restore();
                }
            }
        });
    })();

    return t;
})();
